import React, {
    useState,
    useMemo,
    forwardRef,
    useImperativeHandle,
  } from "react";
  import { Box, Typography } from "@mui/material";
  import { LuPlus } from "react-icons/lu";
  import { FiEdit2, LuTrash2 } from "@/Components/Icons/Icons";
  import entity from "@/Assets/entity.png";
  import EntityTable from "@/Components/Tables/Table";
import FormDialog from "@/Components/Dialog/FormDialog";
  import CreateContactjson from "@/Config/ImportJob/CreateNewCustomer/MoreAddress";
  const CreateCustomerContact = forwardRef((props, ref) => {
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({});
    const [tableData, setTableData] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
  
    //  Expose function to parent via ref
    useImperativeHandle(ref, () => ({
      openNewAddressForm: () => {
        setFormData({});
        setIsEditing(false);
        setShowForm(true);
      },
    }));
  
    // Get all field names from schema
    const allFieldNames = useMemo(() => {
      return CreateContactjson.flatMap((col) =>
        Object.values(col.rows || {}).flatMap((row) =>
          Array.isArray(row) ? row.map((field) => field.name) : []
        )
      ).filter(Boolean);
    }, []);
  
    const handleSubmit = (submission) => {
      const rawValues = submission.data;
      const cleanedData = {};
  
      for (const field of allFieldNames) {
        cleanedData[field] =
          rawValues[field] === undefined || rawValues[field] === ""
            ? "-"
            : rawValues[field];
      }
  
      if (isEditing && cleanedData.id) {
        setTableData((prev) =>
          prev.map((item) => (item.id === cleanedData.id ? cleanedData : item))
        );
      } else {
        cleanedData.id = Date.now();
        setTableData((prev) => [...prev, cleanedData]);
      }
  
      setFormData({});
      setIsEditing(false);
      setShowForm(false);
    };
  
    const handleClose = () => {
      setFormData({});
      setIsEditing(false);
      setShowForm(false);
    };
  
    const handleEdit = (row) => {
      const normalizedFormData = {};
      allFieldNames.forEach((fieldName) => {
        const matchingKey = Object.keys(row).find(
          (key) => key.toLowerCase() === fieldName.toLowerCase()
        );
        normalizedFormData[fieldName] = matchingKey ? row[matchingKey] : "";
      });
      if (row.id) normalizedFormData.id = row.id;
  
      setFormData(normalizedFormData);
      setIsEditing(true);
      setShowForm(true);
    };
  
    const handleDelete = (rowToDelete) => {
      setTableData((prev) => prev.filter((row) => row.id !== rowToDelete.id));
    };
  
    const EmptyState = () => (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          py: "13%",
          gap: 2,
        }}
      >
        <img src={entity} alt="Entity" width={102} height={80} />
        <Typography variant="bodyBase" color="var(--gray-800)">
        Contact not Created yet. <br /> Please "Add New".
        </Typography>
      </Box>
    );
  
    return (
      <Box sx={{ backgroundColor: "var(--gray-0)", width: "100%" }}>
        {tableData.length === 0 && !showForm && <EmptyState />}
  
        {tableData.length > 0 && (
          <Box >
            <EntityTable
              tableData={tableData}
              onEdit={handleEdit}
              onDelete={handleDelete}
              visibleFields={[
               // { key: "contact", label: "Contact Name", width: 150 },
                { key: "Titl", label: "Title/Desgination", width: 150 },
                { key: "Dep", label: "Department", width: 250 },
                { key: "tel", label: "Telephone", width: 150 },
                { key: "Mob", label: "Mobile", width: 150 },
              ]}
              actions={[
                {
                  icon: (
                    <FiEdit2
                      style={{ fontSize: 20, color: "var(--brand-600)" }}
                    />
                  ),
                  title: "Edit",
                  onClick: handleEdit,
                },
                {
                  icon: (
                    <LuTrash2
                      style={{ fontSize: 20, color: "var(--brand-600)" }}
                    />
                  ),
                  title: "Delete",
                  onClick: handleDelete,
                },
              ]}
            />
          </Box>
        )}
  
        {showForm && (
          <FormDialog
            title={isEditing ? "Edit Address" : "Add Contact"}
            schema={CreateContactjson}
            initialData={formData}
            isEditing={isEditing}
            onSubmit={handleSubmit}
            onClose={handleClose}
            showCancelButton={true}
            showSubmitButton={true}
            cancelLabel="Cancel"
            submitLabel={isEditing ? "Save" : "Add"}
          />
        )}
      </Box>
    );
  });
  
  export default CreateCustomerContact;
  